export default __webpack_public_path__ + "static/media/improve_icon.165af6c5.svg";